import api from "./api";

// LOGIN
export const login = (credentials) =>
  api.post("/auth/login", credentials);

// LOGOUT
export const logout = () =>
  api.post("/auth/logout");

// GET CURRENT USER
export const getCurrentUser = () =>
  api.get("/auth/me");